import {ArticleDetailContent} from '@/src/features/news-articles'
import {PageData} from '@/src/core/domain/entities/page/page-data'
import {ArticleContent} from './screen.detail.content'
import React, {Suspense} from 'react'
import {LoadingContentPage} from '@/src/shared/ui/layout/ui/loading-content-page'

type ArticleProps = PageData<ArticleDetailContent> & {suspense: {content: React.ReactNode}}

export const ArticleScreen = (props: ArticleProps) => {
  return <ArticleContent {...props} suspense={{content: props.suspense.content}} />
}

export const ArticlePageContent = ({promise}: {promise: Promise<any>}) => {
  return (
    <Suspense fallback={<LoadingContentPage />}>
      <ServerRenderContent promise={promise} />
    </Suspense>
  )
}

const ServerRenderContent = async ({promise}: {promise: Promise<any>}) => {
  const {html: nodes} = await promise

  return nodes
}
